var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { MAXMIND_URL } from '../settings';
export const useGeoLocation = () => {
    const [geoLocation, setGeoLocation] = useState();
    const updateLocation = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { data } = yield axios.get(MAXMIND_URL);
            localStorage.setItem('bitcoincom-country', data.countryCode);
            setGeoLocation(data.countryCode);
        }
        catch (error) {
            console.log('Error getting location', error);
        }
    }), []);
    useEffect(() => {
        const storedLocation = localStorage.getItem('bitcoincom-country');
        if (storedLocation) {
            setGeoLocation(storedLocation);
        }
        updateLocation();
    }, []);
    return geoLocation;
};
//# sourceMappingURL=useGeoLocation.js.map